import React, { Component } from "react";
import Footer from "../../Components/Footer";
import NavBar from "../../Components/NavBar";

class TermsAndCondition extends Component {
  render() {
    return (
      <div>
        <NavBar />
        <div className="container footer-con">
          <h1>Terms and Conditions</h1>
          <p>
            <strong>Last updated: Feb 19th, 2025</strong>
          </p>
          {/* <p>
            -PLEASE READ THESE TERMS AND CONDITIONS OF USE CAREFULLY. BY USING
            THIS SITE, YOU AGREE TO ABIDE BY THESE TERMS AND CONDITIONS, WHICH
            WILL CONSTITUTE OUR AGREEMENT (“AGREEMENT”).
          </p> */}
          <p>
            BookMyTrek (hereafter referred to as "BookMyTrek ","we", "us", or
            "our") provides an online platform that connects Operators who have
            knowledge and experience with a particular travel destination or
            activity with Adventurers seeking to experience such destinations
            and activities (collectively with the Site and Application (each as
            defined below), the "Services").
          </p>
          <p>
            BookMyTrek (hereafter referred to as "BookMyTrek ","we", "us", or
            "our") provides an online platform that connects Operators who have
            knowledge and experience with a particular travel destination or
            activity with Adventurers seeking to experience such destinations
            and activities (collectively with the Site and Application (each as
            defined below), the "Services").
          </p>
          <p>
            Please carefully read these Terms and our Privacy Policy and our
            Legal Notice, each of which is incorporated by reference into these
            Terms. If you do not agree to these Terms, you have no right to
            obtain information from or otherwise continue using the Services.
            Failure to use the Services in accordance with these Terms may
            subject you to civil and criminal penalties.
          </p>
          <p>
            THE SERVICES COMPRISE AN ONLINE PLATFORM THROUGH WHICH OPERATORS
            (DEFINED BELOW) MAY CREATE LISTINGS (DEFINED BELOW) FOR GROUP TOURS
            (DEFINED BELOW) AND TRAVELLERS (DEFINED BELOW) MAY LEARN ABOUT AND
            BOOK SUCH GROUP TOURS. YOU UNDERSTAND AND AGREE THAT BookMyTrek IS
            NOT A PARTY TO ANY AGREEMENTS ENTERED INTO BETWEEN OPERATORS AND
            TRAVELLERS, NOR IS BookMyTrek AN AGENT OR INSURER. BookMyTrek HAS NO
            CONTROL OVER THE CONDUCT OF OPERATORS, TRAVELLERS AND OTHER USERS OF
            THE SERVICES OR ANY GROUP TOURS, AND DISCLAIMS ALL LIABILITY IN THIS
            REGARD.
          </p>
          <h4>Key Terms</h4>
          <p>
            "Collective Content" means Member Content and BookMyTrek Content.
            "Content" means text, graphics, images, music, software (excluding
            the Application), audio, video, information or other materials.
            "Operator, Service provider or Vendor" means a Member who creates a
            Listing via the Services. "Listing" means an Activity or Tour that
            is listed by an Operator as available for booking via the Services.
            "Member" means a person who completes BookMyTrek's account
            registration process, including, but not limited to Operators and
            Travellers, as described under "Account Registration" below. "Member
            Content" means all Content that a Member posts, uploads, publishes,
            submits or transmits to be made available through the Services.
            "Tax" or "Taxes" mean any sales taxes, value added taxes (VAT),
            goods and services taxes (GST) and other similar municipal, state
            and federal indirect or other withholding and personal or corporate
            income taxes. "BookMyTrek Content" means all Content that BookMyTrek
            makes available through the Services, including any Content licensed
            from a third party, but excluding Member Content. "Traveller" means
            a Member who requests a booking of a Group Tour via the Services, or
            a Member who participates in a Group Tour and is not the Operator
            for such Tour. Certain portions of the Services (and your access to
            or use of certain aspects of the Services or Collective Content) may
            have different terms and conditions posted or may require you to
            agree with and accept additional terms and conditions. If there is a
            conflict between these Terms and terms and conditions posted for a
            specific portion of the Services, or Collective Content, the latter
            terms and conditions will take precedence with respect to your use
            of or access to that portion of the Services, or Collective Content.
          </p>
          <p>
            YOU ACKNOWLEDGE AND AGREE THAT, BY ACCESSING OR USING THE SERVICES
            OR BY DOWNLOADING OR POSTING ANY CONTENT FROM OR ON THE SITE, VIA
            THE APPLICATION OR OTHERWISE THROUGH THE SERVICES YOU ARE INDICATING
            THAT YOU HAVE READ, AND THAT YOU UNDERSTAND AND AGREE TO BE BOUND BY
            THESE TERMS, WHETHER OR NOT YOU HAVE REGISTERED WITH THE SERVICES.
            IF YOU DO NOT AGREE TO THESE TERMS, THEN YOU HAVE NO RIGHT TO ACCESS
            OR USE THE SERVICES, OR COLLECTIVE CONTENT.
          </p>
          <p>
            If you accept or agree to these Terms on behalf of a company or
            other legal entity, you represent and warrant that you have the
            authority to bind that company or other legal entity to these Terms
            and, in such event, "you" and "your" will refer and apply to that
            company or other legal entity.
          </p>
          <h4>Modification</h4>
          <p>
            BookMyTrek reserves the right, at its sole discretion, to modify the
            Services at any time and without prior notice. If we modify these
            Terms, we will post the modification on the Site or via the Services
            or provide you with notice of the modification. We will also update
            the "Last Updated Date" at the top of these Terms. Any changes will
            become effective immediately upon your acceptance of the modified
            Terms, whether by, without limitation, creating a Listing or
            requesting the booking of a Group Tour. If the modified Terms are
            not acceptable to you, your only recourse is to cease using the
            Services.
          </p>
          <h4>Eligibility</h4>
          <p>
            The Services can be used to facilitate the listing, reviewing,
            searching, comparing, meeting other people, entering contests and
            booking of tours and adventurous activities ("Group Tours"). Such
            Group Tours or Group Adventurous Activities are included in Listings
            on the Services by Operators. You may view Listings as an
            unregistered visitor to the Services; however, if you wish to book a
            Tour or Adventurous Activity or create a Listing, you must either
            register to create a BookMyTrek Account (defined below) or provide
            your email address. As stated above, BookMyTrek makes available a
            platform or marketplace with related technology for Travellers and
            Operators to meet online, write reviews, search, compare, enter
            contests and arrange for bookings of Group Tours. BookMyTrek is not
            an operator of tours, activities or other Group Tours, nor is it a
            provider of group tours or activities and BookMyTrek does not own,
            sell, resell, furnish, provide, manage and/or control any
            transportation, tour or travel services.
          </p>
          <p>
            For any kind of visa, inner line permits, forest department or
            government permissions and tickets to entrance parks which are part
            of your itinerary, please check with the tour operator or plan them
            in advance. BookMyTrek does not provide these services or checks any
            of these services. BookMyTrek only facilitates ticket booking and
            does not take any guarantee of any kind of permissions or tickets
            required in course of your tour itinerary. In case you miss and do
            not have required documents due to which you are not able to
            complete your tour, BookMyTrek or tour operator will not be liable
            for the act.
          </p>
          <p>
            BookMyTrek responsibilities are limited to facilitating the
            availability of the Services and serving as the limited agent of
            each Operator for the purpose of accepting payments from Travellers
            on behalf of the Operator.
          </p>
          <p>
            PLEASE NOTE THAT, AS STATED ABOVE, THE SERVICES ARE INTENDED TO BE
            USED TO FACILITATE THE BOOKING OF GROUP TOURS. BookMyTrek CANNOT AND
            DOES NOT CONTROL THE CONTENT CONTAINED IN ANY LISTINGS AND THE
            CONDITION, LEGALITY OR SUITABILITY OF ANY GROUP TOURS. BookMyTrek IS
            NOT RESPONSIBLE FOR AND DISCLAIMS ANY AND ALL LIABILITY RELATED TO
            ANY AND ALL LISTINGS AND TOURS. ACCORDINGLY, ANY BOOKINGS WILL BE
            MADE AT THE TRAVELER'S OWN RISK.
          </p>
          <h4>Account Registration</h4>
          <p>
            For Operators - Tour operators that wish to take advantage of
            BookMyTrek services and sell their tours/adventurous events on the
            https://www.bookmytrek.com Global Marketplace need to first submit
            their application. BookMyTrek reviews all sign up requests and
            assesses the compatibility of the tour operators' product with the
            https://www.bookmytrek.com Marketplace. This review process can take
            up to 2 weeks as the product, company, market fit, bonding, safety
            and global reputation of the company is assessed. Upon reviewing the
            sign up request the BookMyTrek team informs the operator whether or
            not working together is possible. BookMyTrek reserves the right to
            decline the application at this stage, or any other, stage. If the
            first screening is positive, the operator will be asked to fill out
            an application form and submit it to the BookMyTrek team. Once this
            form is accepted, processed and the application is confirmed by
            BookMyTrek, BookMyTrek will guide the operator through the next sign
            up steps, which includes uploading tour listings, installation of
            tools like Facebook Applications and assists the operator wherever
            possible. Before BookMyTrek can start driving bookings for the
            operator, the operator must agree to BookMyTrek Terms and Conditions
            in writing via e-mail.
          </p>
          <p>
            For Travellers - In order to access certain features of the Services
            and to book a Tour, you can create an account ("BookMyTrek Account")
            and become a Member. You may register to join the Services directly
            via the Site or Application using the link at the top of any page or
            as otherwise described in this section. You may also be able to
            register to join by logging into your account with certain third
            party social networking sites ("SNS") (including, but not limited
            to, Facebook); each such account, a "Third Party Account", via our
            Site or Application, as described below. As part of the
            functionality of the Services, you may be able to link your
            BookMyTrek Account with Third Party Accounts, by either providing
            your Third Party Account login information to BookMyTrek through the
            Services; or allowing BookMyTrek to access your Third Party Account,
            as is permitted under the applicable terms and conditions that
            govern your use of each Third Party Account. You represent that you
            are entitled to disclose your Third Party Account login information
            to BookMyTrek and/or grant BookMyTrek access to your Third Party
            Account (including, but not limited to, for use for the purposes
            described herein), without breach by you of any of the terms and
            conditions that govern your use of the applicable Third Party
            Account and without obligating BookMyTrek to pay any fees or making
            BookMyTrek subject to any usage limitations imposed by such third
            party service providers. By granting BookMyTrek access to any Third
            Party Accounts, you understand that BookMyTrek may access, make
            available and store (if applicable) any content that you have
            provided to and stored in your Third Party Account ("SNS Content")
            so that it is available on and through the Services via your
            BookMyTrek Account and BookMyTrek Account profile page. You agree
            that BookMyTrek may request your email address, access to photos;
            friends list to help verify your identity; share your updates and
            photos; and to be contacted by us. Unless otherwise specified in
            these Terms, all SNS Content, if any, will be considered to be
            Member Content for all purposes of these Terms. Depending on the
            Third Party Accounts you choose and subject to the privacy settings
            that you have set in such Third Party Accounts, personally
            identifiable information that you post to your Third Party Accounts
            may be available on and through your BookMyTrek Account on the
            Services. Please note that if a Third Party Account or associated
            service becomes unavailable or BookMyTrek access to such Third Party
            Account is terminated by the third party service provider, then SNS
            Content may no longer be available on and through the Services. You
            have the ability to configure certain portions of the connection
            between your BookMyTrek Account and your Third Party Accounts, at
            any time, by accessing the "Profile" section of the Services.
          </p>
          <p>
            PLEASE NOTE THAT YOUR RELATIONSHIP WITH THE THIRD PARTY SERVICE
            PROVIDERS ASSOCIATED WITH YOUR THIRD PARTY ACCOUNTS IS GOVERNED
            SOLELY BY YOUR AGREEMENT(S) WITH SUCH THIRD PARTY SERVICE PROVIDERS.
          </p>
          <p>
            BookMyTrek makes no effort to review any SNS Content for any
            purpose, including but not limited to, for accuracy, legality or
            non-infringement and BookMyTrek is not responsible for any SNS
            Content. We will create your BookMyTrek Account and your BookMyTrek
            Account profile page for your use of the Services based upon the
            personal information you provide to us or that we obtain via an SNS
            as described above. You may not have more than one (1) active
            BookMyTrek Account. You agree to provide accurate, current and
            complete information during the registration process and to update
            such information to keep it accurate, current and complete.
            BookMyTrek reserves the right to suspend or terminate your
            BookMyTrek Account and your access to the Services if you create
            more than one (1) BookMyTrek Account or if any information provided
            during the registration process or thereafter proves to be
            inaccurate, not current or incomplete. You are responsible for
            safeguarding your password. You agree that you will not disclose
            your password to any third party and that you will take sole
            responsibility for any activities or actions under your BookMyTrek
            Account, whether or not you have authorized such activities or
            actions. You will immediately notify BookMyTrek of any unauthorized
            use of your BookMyTrek Account. https://www.bookmytrek.com performs
            regular backups on all servers to ensure critical files are never
            lost. However BookMyTrek is NOT responsible for lost data, time,
            income or any other resource due to faulty backups or non-existent
            backups. Please always backup your own data for Redundancy
          </p>
          <h4>Tour Listings</h4>
          <p>
            Operators may create Listings. To this end, you will be asked a
            variety of questions about the Tour to be listed, including, but not
            limited to, the location, capacity, itinerary, and features,
            availability of the Group Tour and pricing and related rules and
            financial terms. Operators working with BookMyTrek are responsible
            for making sure that their tour listings on the
            https://www.bookmytrek.com Marketplace are up-to-date so that
            travellers who wish to book their tours are presented with correct
            information. Tour operators are responsible for updating their tour
            information - either manually using the BookMyTrek Dashboard, or by
            supplying the BookMyTrek team with a fully functional information
            over email. Listings will be made publicly available via the
            Services. Other Members will be able to book your Tours via the
            Services based upon the information provided in your Listing. You
            acknowledge and agree that you are responsible for any and all
            Listings you post. Accordingly, you represent and warrant that any
            Listing you post and the booking of, or Traveller taking of, a Tour
            in a Listing you post will not breach any agreements you have
            entered into with any third parties (such as any agreements with or
            rules of employers or local tourism agencies) and will be in
            compliance with all applicable laws, Tax requirements, and rules and
            regulations that may apply to any Group Tour included in a Listing
            you post, including, but not limited to, tourism, tour guide
            licensing laws, and other laws governing events and tours of public
            spaces and other venues and not conflict with the rights of third
            parties. Please note that BookMyTrek assumes no responsibility for
            an Operator's compliance with any applicable laws, rules and
            regulations.
          </p>
          <p>
            BookMyTrek reserves the right, at any time and without prior notice,
            to remove or disable access to any Listing for any reason, including
            Listings that BookMyTrek, in its sole discretion, considers to be
            objectionable for any reason, in violation of these Terms or
            otherwise harmful to the Services. You understand and agree that
            BookMyTrek does not act as an insurer or as a contracting agent for
            you as an Operator. If a Traveller requests a booking of your Group
            Tour and participates in your Group Tour, any agreement you enter
            into with such Traveller is between you and the Traveller and
            BookMyTrek is not a party thereto.
          </p>
          <p>
            Notwithstanding the foregoing, BookMyTrek serves as the limited
            authorized agent of the operator for the purpose of accepting
            payments from the traveller on behalf of the Operator and is
            responsible for transmitting such payments to the operator, subject
            to these Terms. When you create a Listing, you may also choose to
            include certain requirements, which must be met by the Members who
            are eligible to request a booking of your Tour. Any member wishing
            to book tours included in Listings with such requirements must meet
            these requirements. You acknowledge and agree that, as an operator,
            you are responsible for your own acts and omissions and are also
            responsible for the acts and omissions of any individuals who are
            present during the group tour at your request or invitation,
            excluding the traveller. BookMyTrek recommends that operators obtain
            appropriate insurance for their Tours. Please review any insurance
            policy that you may have for your tour carefully, and in particular
            please make sure that you are familiar with and understand any
            exclusions to, and any deductibles that may apply for, such
            insurance policy, including, but not limited to, whether or not your
            insurance policy will cover the actions or inactions of travellers
            while participating in your group tour.
          </p>
          {/* <p>
            We provide social media features:{" "}
            <a className="alinks" href="https://www.facebook.com/bookmytrekapp">
              https://www.facebook.com/bookmytrekapp
            </a>{" "}
            and{" "}
            <a className="alinks" href="https://www.instagram.com/bookmytrek/">
              https://www.instagram.com/bookmytrek/
            </a>{" "}
            with certain content, you may take such actions as are enabled by
            such features.
          </p> */}
          <h4>No Endorsement</h4>
          <p>
            BookMyTrek does not endorse any Members or any Tours. In addition,
            although these Terms require Members to provide accurate
            information, we do not attempt to confirm, and do not confirm, any
            Member's purported identity. You are responsible for determining the
            identity and suitability of others who you contact via the Services.
            We will not be responsible for any damage or harm resulting from
            your interactions with other Members. By using the Services, you
            agree that any legal remedy or liability that you seek to obtain for
            actions or omissions of other Members or other third parties will be
            limited to a claim against the particular Members or other third
            parties who caused you harm and you agree not to attempt to impose
            liability on, or seek any legal remedy from BookMyTrek with respect
            to such actions or omissions. Accordingly, we encourage you to
            communicate directly with other Members via the Services regarding
            any bookings or Listings made by you. This limitation shall not
            apply to any claim by an Operator against BookMyTrek regarding the
            remittance of payments received from a Traveller by BookMyTrek on
            behalf of an Operator, which instead shall be subject to the
            limitations described in the section below entitled "Limitation of
            Liability".
          </p>
          <h4>Bookings and Financial Terms for Operators</h4>
          <p>
            If you are an Operator and a booking is requested for your Group
            Tour via the Services, you will be required to either confirm or
            decline the booking using BookMyTrek’s Messaging System within the
            specified timeframe (which is generally within 24 hours of when the
            booking is requested, as determined by BookMyTrek in its sole
            discretion) or the booking request will be automatically accepted.
            If you decide to decline a booking of a Tour within the specified
            timeframe, any amounts collected by BookMyTrek for the requested
            booking will be refunded to the applicable Traveller's credit card
            and any pre-authorization of such credit card will be released. You
            understand and agree that once a Traveller requests a booking of
            your Group Tour, the price for such booking may not be altered after
            you confirm the booking without first obtaining the Travellers
            consent. If you have not yet confirmed the Traveller's booking you
            can amend the price, details, add discounts, food funds, single
            supplements and other local payment so long as you advise the
            Traveller of these changes before you confirm the booking to allow
            Travellers to consent to your changes.
          </p>
          <p>
            When a booking is requested via the Services, we may share with you
            the first and last name of the Traveller who has requested the
            booking. The Deposit amount displayed on the booking page is set by
            you. Where applicable, Taxes may be charged in addition to the Group
            Tour Cost. The Group Tour Cost and applicable Taxes are collectively
            referred to in these Terms as the "Total Cost". The amounts due and
            payable by a Traveller solely relating to an Operator's Group Tour
            are the "Tour Cost". Please note that it is you and not BookMyTrek
            which determines the Tour Cost and you agree this Cost will be
            exactly the same Cost stated on your website.
          </p>
          <p>
            If the Departure is 60 days, unless otherwise stated on the tour
            page, or more from the booking date, BookMyTrek will only collect
            the Deposit at the time of booking confirmation (i.e. when you
            confirm the booking within the specified timeframe). The Balance of
            Payment (defined as the Group Tour Cost minus the Deposit) will be
            automatically collected from the Traveller by us, 60 days, unless
            otherwise stated on the tour page, prior to the departure date,
            unless otherwise stated on the tour page. BookMyTrek is only liable
            to pay to the Operator the payments collected from the Traveller
            minus BookMyTrek Service Fee. If the Traveller's Balance of Payment
            transaction fails on the due date, the Operator agrees to provide
            the Traveller with a grace period of 5 days to pay the Balance of
            Payment via BookMyTrek E2B. If the Balance of Payment remains unpaid
            prior to the departure date the Operator may choose to cancel the
            Traveller's booking where the Deposit will be forfeited. Or the
            Operator may choose to extend the grace period as the Operator
            determines. If a booking is found to be fraudulent by the BookMyTrek
            Team, we will notify you and you must cancel any invoice to
            BookMyTrek. After you confirm a booking, you are responsible for
            invoicing BookMyTrek for the original tour price listed in the
            BookMyTrek.com tour listing at the point of booking request (which
            must correspond to the pricing on your website) minus BookMyTrek's
            Service fee. BookMyTrek's Service fee are displayed in your
            BookMyTrek Dashboard. Invoices are to be emailed to
            finance@BookMyTrek.com. Invoices must have a payment due date of the
            5th business day of the next calendar month after the tour departure
            date. Each tour booking must have its own invoice. BookMyTrek will
            pay the Net Amount (defined as being the Group Tour Cost minus the
            Service Fee) to your nominated bank account. We are not responsible
            for delays in remitting Tour Fees, which can vary based on the bank,
            currency, location, etc. We are responsible for emailing the
            Traveller with a booking receipt for their payments. You are
            responsible for emailing any documentation, other necessary details
            and vouchers to the Traveller.
          </p>
          <h4>Appointment of BookMyTrek as Payment Agent for Operator</h4>
          <p>
            Each Operator hereby appoints BookMyTrek as the Operator's limited
            agent solely for the purpose of collecting payments made by
            Travellers on behalf of the Operator. Each Operator agrees that
            payment made by a Traveller to BookMyTrek shall be considered the
            same as a payment made directly to the Operator and the Operator
            will make the Group Tour available to Traveller in the agreed upon
            manner as if the Operator has received the Part Payment. In
            accepting appointment as the limited authorized agent of the
            Operator, BookMyTrek assumes no liability for any acts or omissions
            of the Operator. Operators acknowledge and agree that BookMyTrek
            reserves the right, in its sole discretion, to introduce and collect
            other fees from you in accordance with the Modification Section of
            these Terms. Please note that BookMyTrek will provide notice of new
            fees via the Services, prior to implementing such new features.
          </p>
          <h4>Bookings and Financial Terms for Travellers</h4>
          <p>
            The Operators, not BookMyTrek , are solely responsible for honouring
            any confirmed bookings and making available any Group Tours reserved
            through the Services. If you, as a Traveller, choose to enter into a
            transaction with an Operator for the booking of a Group Tour, you
            agree and understand that you will be required to enter into an
            agreement (including releases) with the Operator and you agree to
            accept any terms, conditions, rules and restrictions associated with
            such Tour imposed by the Operator. Operators may not change the Tour
            Cost after a booking has been confirmed unless the Operator asks for
            your Consent (changes might include additional services that you
            request from the Operator). If a booking has not yet been confirmed
            by the Operator, the Operator may change the price, details, add
            discounts, local payments and other services requested by you but
            the Operator must notify you of this change and you must consent to
            this change before the Operator can confirm your booking. You
            acknowledge and agree that you, and not BookMyTrek , will be
            responsible for performing the obligations of any such agreements,
            that BookMyTrek is not a party to such agreements, and that, with
            the exception of its payment obligations hereunder, BookMyTrek
            disclaims all liability arising from or related to any such
            agreements. You acknowledge and agree that, notwithstanding the fact
            that BookMyTrek is not a party to any agreements between you and the
            Operator, BookMyTrek acts as the Operator's payment agent for the
            limited purpose of accepting payments from you on behalf of the
            Operator. Upon your payment of amounts to BookMyTrek which are due
            to the Operator, your payment obligation to the Operator is
            extinguished, and BookMyTrek will remit to the Operator the
            difference between the Tour Cost minus the Service Fee (defined
            below). The secure payment provider that BookMyTrek uses to process
            all payments is EBS or Razorpay or PayU.
          </p>
          <p>
            The Operators, not BookMyTrek , are solely responsible for honouring
            any confirmed bookings and making available any Group Tours reserved
            through the Services. If you, as a Traveller, choose to enter into a
            transaction with an Operator for the booking of a Group Tour, you
            agree and understand that you will be required to enter into an
            agreement (including releases) with the Operator and you agree to
            accept any terms, conditions, rules and restrictions associated with
            such Tour imposed by the Operator. Operators may not change the Tour
            Cost after a booking has been confirmed unless the Operator asks for
            your Consent (changes might include additional services that you
            request from the Operator). If a booking has not yet been confirmed
            by the Operator, the Operator may change the price, details, add
            discounts, local payments and other services requested by you but
            the Operator must notify you of this change and you must consent to
            this change before the Operator can confirm your booking. You
            acknowledge and agree that you, and not BookMyTrek , will be
            responsible for performing the obligations of any such agreements,
            that BookMyTrek is not a party to such agreements, and that, with
            the exception of its payment obligations hereunder, BookMyTrek
            disclaims all liability arising from or related to any such
            agreements. You acknowledge and agree that, notwithstanding the fact
            that BookMyTrek is not a party to any agreements between you and the
            Operator, BookMyTrek acts as the Operator's payment agent for the
            limited purpose of accepting payments from you on behalf of the
            Operator. Upon your payment of amounts to BookMyTrek which are due
            to the Operator, your payment obligation to the Operator is
            extinguished, and BookMyTrek will remit to the Operator the
            difference between the Tour Cost minus the Service Fee (defined
            below). The secure payment provider that BookMyTrek uses to process
            all payments is EBS or Razorpay or PayU.
          </p>
          <h4>Service Fees only apply to Operators</h4>
          <p>
            In consideration for providing the Services, BookMyTrek collects a
            service fee only from Operators ("Service Fees"). A Service Fee is
            made up of the based upon a percentage of the amount of the Group
            Tour Cost which is defined in the Operator's BookMyTrek T n C. Where
            applicable, Taxes may also be charged in addition to the Service
            Fee. Services Fees are deducted from the Group Tour Cost before
            remitting the balance to the Operator (please note that we will not
            be responsible for delays in remitting Group Tour Fees, which can
            vary based on the bank, currency, location, etc). Balances will be
            remitted by BookMyTrek to Operators via cheque, direct deposit or
            other payment methods described on the Site or via the Application,
            in the Operator's currency of choice, depending upon the selections
            the Operator makes via the Services. Please note that for any
            payments by BookMyTrek , we will pay our bank's costs and and you
            are responsible to pay your bank's costs. More information on
            Service Fees can be found in your Dashboard by going to Profile
            BookMyTrek Package. Except as otherwise provided herein, Service
            Fees are non-refundable.
          </p>
          <h4>
            General Booking and Financial Terms Traveller Cancellations, Refunds
            and Complaints
          </h4>
          <p>
            If, as a Traveller, you cancel your requested booking by raising a
            ticket, if the Operator declines your booking request due to non
            availability which will automatically cancel any pre-authorization
            to your credit card and/or refund any nominal amounts charged to
            your credit card in connection with the requested booking within a
            commercially reasonable time (7-10 business days). You agree to pay
            BookMyTrek the Deposit for any booking requested in connection with
            your BookMyTrek Account if such requested bookings are confirmed by
            the Operator. Once your booking is confirmed and you have received
            email acknowledgement, what you have paid is non-refundable. If
            cancellation is made within 31 days to departure 100% of these costs
            will be forfeited. Cancellation of permits will result in the costs
            being 100% forfeited.
          </p>
          <p>
            Neither BookMyTrek nor the Operators selling their tours on
            BookMyTrek .com offer or pay any discounts or refunds for missed or
            unused services which were missed or unused by the traveller due to
            no fault of BookMyTrek , or operators working with = "BookMyTrek " |
            , which shall include any termination of the traveller's
            participation in the tour due to the traveller's own fault,
            negligence or breach of these Terms. All traveller complaints about
            their experience on tour will be passed onto the tour operator's
            team to resolve. BookMyTrek is committed to working with tour
            operators to achieve a high level of service. If the response time
            and/or response quality of the tour operator however continue to
            fall below acceptable timing and quality despite our working
            together to rectify any issues, BookMyTrek reserves the right to
            remove the operators' tour listings from BookMyTrek .com
            Marketplace, Affiliate websites, Mobile Apps and remove any
            Applications provided by us.
          </p>
          <h4>Unforeseen Circumstances Operator Cancellations and Refunds</h4>
          <p>
            If an Operator cancels a confirmed booking made via the
            Services,BookMyTrek will refund any Payment for such booking to the
            applicable Traveller within a commercially reasonable time of the
            cancellation andthe Traveller may receive an email or other
            communication from BookMyTrek containing alternative Listings and
            other related information. If the Traveller requests a booking from
            one of the alternative Listings this will be treated like a new
            group tour booking. If an Operator cancelled a confirmed booking and
            you, as a Traveller, have not received an email or other
            communication from BookMyTrek , please contact BookMyTrek at
            contact@bookmytrek.com
          </p>
          <h4>Cancellation in the Event of Inclement Weather</h4>
          <p>
            Certain Tours may be weather-dependent. Notwithstanding the
            foregoing, in the event of inclement weather, the Operator has the
            discretion as to whether the weather conditions will prevent the
            Tour from taking place. As an Operator, if you need to cancel an
            Group Tour for reasons of inclement weather, you must contact the
            Traveller and BookMyTrek (at booking@bookmytrek.com as early as
            possible. Subject to the Traveller's consent, the Operator and the
            Traveller may choose to reschedule the Group Tour for another date.
            If the Group Tour cannot be rescheduled, as a Traveller, please
            contact BookMyTrek so we may assist in finding a replacement,
            non-weather-dependent Group Tour. For clarity, in the event the
            alternative Group Tour is of a higher price than the former, you may
            be responsible for any difference in price. In the event the
            alternative Group Tour is of a lower price, you may be entitled to a
            partial refund for the difference. As a Traveller, if you have
            contacted BookMyTrek as provided above and BookMyTrek is unable to
            find you a replacement Group Tour, BookMyTrek may refund the Payment
            for such booking to the Traveller within a commercially reasonable
            time of the cancellation.
          </p>
          <h4>Taxes</h4>
          <p>
            You understand and agree that you are solely responsible for
            determining your applicable Tax reporting requirements in
            consultation with your tax advisors. BookMyTrek cannot and does not
            offer Tax-related advice to any Members of the Services.
            Additionally, please note that each Operator is responsible for
            determining local indirect Taxes and for including any applicable
            Taxes to be collected or obligations relating to applicable Taxes in
            Listings.
          </p>
          <h4>Foreign Currency</h4>
          <p>
            As part of the Services, BookMyTrek may provide a feature through
            which Travellers may view prices for various Listings in foreign
            currencies. You understand and agree that these views of prices are
            for informational purposes only and may not be the official local
            price for the Operator's Listings. If you (as a Traveller) request a
            booking, you will be notified of the currency in which you will be
            charged together with the corresponding amount of the Payment, if
            your booking is confirmed by an Operator. The currency in which you
            will be charged may be determined by BookMyTrek based on the payment
            method you select and the location of the Group Tour in the Listing
            you are booking. If the currency in which you will be charged is
            different from the currency chosen by the Operator to receive
            payment, BookMyTrek will be responsible for the required currency
            conversion processing, including the costs thereof, which will be
            calculated based on the most current applicable foreign exchange
            rate that BookMyTrek has uploaded to the Site as of the date and
            time that your booking is confirmed (the "Applicable Exchange
            Rate"). You acknowledge that the Applicable Exchange Rate used for
            currency conversion processing may not be identical to the
            applicable market rate in effect at the specific time such
            processing occurs because:although BookMyTrek would update the
            Applicable Exchange Rate on a regular basis, it would not update
            such rate on a real-time basis; andthe Applicable Exchange Rate may
            include an incremental cost or margin that is not included in the
            applicable market rate. For the avoidance of doubt, BookMyTrek would
            retain any profits (and will bear any losses) that result from such
            currency conversion processing due to changes in the applicable
            foreign exchange rate between the date your booking is confirmed and
            the date BookMyTrek makes payment to an Operator.
          </p>
          <h4>Member Conduct</h4>
          <p>
            You understand and agree that you are solely responsible for
            compliance with any and all laws, rules, regulations, and Tax
            obligations that may apply to your use of the Site, Application,
            Services and Content. In connection with your use of the Services,
            you may not and you agree that you will not: violate any local,
            state, provincial, national, or other law or regulation, or any
            order of a court, including, without limitation, zoning restrictions
            and Tax regulations; use manual or automated software, devices,
            scripts robots, other means or processes to access, "scrape,"
            "crawl" or "spider" any web pages or other services contained in the
            Site, Application, Services or Content; use the Services for any
            commercial or other purposes that are not expressly permitted by
            these Terms; copy, store or otherwise access any information
            contained on the Services or Content for purposes not expressly
            permitted by these Terms; infringe the rights of any person or
            entity, including without limitation, their intellectual property,
            privacy, publicity or contractual rights; interfere with or damage
            the Services, including, without limitation, through the use of
            viruses, cancel bots, Trojan horses, harmful code, flood pings,
            denial-of-service attacks, packet or IP spoofing, forged routing or
            electronic mail address information or similar methods or
            technology; use the Services to transmit, distribute, post or submit
            any information concerning any other person or entity, including
            without limitation, photographs of others without their permission,
            personal contact information or credit, debit, calling card or
            account numbers; use the Services in connection with the
            distribution of unsolicited commercial email ("spam") or
            advertisements unrelated to Group Tours; "stalk" or harass any other
            user of the Services or collect or store any personally identifiable
            information about any other user other than for purposes of
            transacting as a BookMyTrek Traveller or Operator; offer, as an
            Operator, any Group Tours that you do not yourself have permission
            to provide (without limiting the foregoing, you will not list Group
            Tours as an Operator if you are serving in the capacity of an agent
            for a third party); offer, as an Operator, any Group Tour that may
            not be provided pursuant to the terms and conditions of an agreement
            with a third party; register for more than one BookMyTrek Account or
            register for a BookMyTrek Account on behalf of an individual other
            than yourself; contact an Operator for any purpose other than asking
            a question related to a booking, such Operator's Group Tours or
            Listings; contact a Traveller for any purpose other than asking a
            question related to a booking or such Traveller's use of the
            Services; when acting as a Traveller or otherwise, recruit or
            otherwise solicit any Operator or other Member to join third party
            services or websites that are competitive to BookMyTrek , without
            BookMyTrek 's prior written approval (for clarity and without
            diminishing any of = "BookMyTrek " | 's rights to enforce these
            Terms, BookMyTrek may cancel such offending Member's BookMyTrek
            Account, permanently block such Member from access to the Service,
            and take any legal action BookMyTrek deems appropriate against such
            Member, including by prosecuting such Member to the fullest extent
            of the law); impersonate any person or entity, or falsify or
            otherwise misrepresent yourself or your affiliation or
            non-affiliation with any person or entity, or otherwise post any
            reviews that exhibit a conflict of interest (for example, by posting
            reviews for your or your employer's Listing); use automated scripts
            to collect information or otherwise interact with the Services; use
            the Services to find an Operator or Traveller and then complete a
            booking of an Group Tour transaction independent of the Services,
            whether or not you do so in order to circumvent the obligation to
            pay any Service Fees related to BookMyTrek 's provision of the
            Services; as an Operator, submit any Listing with a false or
            misleading price information, or submit any Listing with a price
            that you do not intend to honor; post, upload, publish, submit or
            transmit any Content that:infringes, misappropriates or violates a
            third party's patent, copyright, trademark, trade secret, moral
            rights or other intellectual property rights, or rights of publicity
            or privacy;violates, or encourages any conduct that would violate,
            any applicable law or regulation or would give rise to civil
            liability;is fraudulent, false, misleading or deceptive;is
            defamatory, obscene, pornographic, vulgar or offensive;promotes
            discrimination, bigotry, racism, hatred, harassment or harm against
            any individual or group;is violent or threatening or promotes
            violence or actions that are threatening to any other person; or
            (vii) promotes illegal or harmful activities or substances;
            systematically retrieve data or other content from the Services to
            create or compile, directly or indirectly, in single or multiple
            downloads, a collection, compilation, database, directory or the
            like, whether by manual methods, through the use of bots, crawlers,
            or spiders, or otherwise; use, display, mirror or frame any portion
            of the Services, or any individual element within the Services,
            BookMyTrek 's name, any BookMyTrek trademark, logo or other
            proprietary information, or the layout and design of any page or
            form contained on a page, without BookMyTrek 's express written
            consent; access, tamper with, or use non-public areas of the
            Services, BookMyTrek 's computer systems, or the technical delivery
            systems of = "BookMyTrek " | 's providers; attempt to probe, scan,
            or test the vulnerability of any BookMyTrek system or network or
            breach any security or authentication measures; avoid, bypass,
            remove, deactivate, impair, descramble, or otherwise circumvent any
            technological measure implemented by BookMyTrek or any of BookMyTrek
            's providers or any other third party (including another user) to
            protect the Services or Collective Content; forge any TCP/IP packet
            header or any part of the header information in any email or
            newsgroup posting, or in any way use the Services or Collective
            Content to send altered, deceptive or false source-identifying
            information; attempt to decipher, decompile, disassemble or reverse
            engineer any of the software used to provide the Services or
            Collective Content; or advocate, encourage, or assist any third
            party in doing any of the foregoing.
          </p>
          <h4>Privacy</h4>
          <p>
            See BookMyTrek 's Privacy Policy and for information and notices
            concerning BookMyTrek 's collection and use of your personal
            information.
          </p>
          <h4>Ownership</h4>
          <p>
            The Services (including the Site and Application) and Collective
            Content are protected by copyright, trademark, and other laws of
            Austria and foreign countries. You acknowledge and agree that the
            Services (including the Site and Application) and Collective
            Content, including all associated intellectual property rights is
            the exclusive property of BookMyTrek and its licensors. You will not
            remove, alter or obscure any copyright, trademark, service mark or
            other proprietary rights notices incorporated in or accompanying the
            Services (including the Site and Application) or Collective Content.
          </p>
          <h4>BookMyTrek Content and Member Content License</h4>
          <p>
            Subject to your compliance with the terms and conditions of these
            Terms, BookMyTrek grants you a limited, non-exclusive,
            non-transferable license to (i) access and view any BookMyTrek
            Content solely for your personal and non-commercial purposes and
            (ii) access and view any Member Content to which you are permitted
            access, solely for your personal and non-commercial purposes. You
            have no right to sublicense the license rights granted in this
            section.You will not use, copy, adapt, modify, prepare derivative
            works based upon, distribute, license, sell, transfer, publicly
            display, publicly perform, transmit, broadcast or otherwise exploit
            the Services or Collective Content, except as expressly permitted in
            these Terms. No licenses or rights are granted to you by implication
            or otherwise under any intellectual property rights owned or
            controlled by BookMyTrek or its licensors, except for the licenses
            and rights expressly granted in these Terms.
          </p>
          <h4>Member Content</h4>
          <p>
            We may, in our sole discretion, permit Members to post, upload,
            publish, submit or transmit Member Content. By making available any
            Member Content on or through the Services, you hereby grant to
            BookMyTrek a worldwide, irrevocable, perpetual, non-exclusive,
            transferable, royalty-free license, with the right to sublicense, to
            use, view, copy, adapt, modify, distribute, license, sell, transfer,
            publicly display, publicly perform, transmit, stream, broadcast,
            access, view, and otherwise exploit such Member Content on, through,
            or by means of the Services. BookMyTrek does not claim any ownership
            rights in any such Member Content and nothing in these Terms will be
            deemed to restrict any rights that you may have to use and exploit
            any such Member Content. You acknowledge and agree that you are
            solely responsible for all Member Content that you make available
            through the Services. Accordingly, you represent and warrant that:
            (i) you either are the sole and exclusive owner of all Member
            Content that you make available through the Services or you have all
            rights, licenses, consents and releases that are necessary to grant
            to BookMyTrek the rights in such Member Content, as contemplated
            under these Terms; and (ii) neither the Member Content nor your
            posting, uploading, publication, submission or transmittal of the
            Member Content or BookMyTrek 's use of the Member Content (or any
            portion thereof) on, through or by means of the the Services will
            infringe, misappropriate or violate a third party's patent,
            copyright, trademark, trade secret, moral rights or other
            proprietary or intellectual property rights, or rights of publicity
            or privacy, or result in the violation of any applicable law or
            regulation. You must not store illegal content on the Site and we
            will monitor our site regularly for such illegal content. Please be
            aware that if you upload illegal content you could be subject to a
            fine of up to INR 100,000.
          </p>
          <h4>BookMyTrek Promo Codes</h4>
          <p>
            BookMyTrek may offer Promo Codes from time to time providing credits
            for bookings made on BookMyTrek .com and unless otherwise stated
            they have an expiry period of 30 days and are limited to one Promo
            Code per booking. Promo Codes can only be used for bookings for
            tours and the same basis as outlined in the section: Only one Promo
            Code can be added/used per booking and they may be combined with
            Referral Credits.
          </p>
          <h4>BookMyTrek Gift Cards</h4>
          <p>
            BookMyTrek enables anyone to purchase a Gift Card for varying
            currencies and denominations either for themselves or as gifts for
            friends and family. BookMyTrek 's Gift Cards may be used for any
            tour that can be booked and paid for on BookMyTrek .com. Unless
            otherwise specified or stated, multiple Gift Cards can be used when
            booking a tour; there is no minimum spend; and are combinable with =
            "BookMyTrek " | 's Travel Credits and Promo Codes. Gift Cards must
            be used in the currency they are issued in and they cannot be
            redeemed for cash or similar. Gift Cards have an expiry date of 12
            months from the date of purchase and must be added to a tour booking
            within this 12 month period however the departure date of the tour
            does not need to be within 12 months. Gift cards can only be used
            one time, it is your responsibility to make sure the value of the
            tour being booked is greater than the value of the Gift Card as the
            balance cannot be carried over. Card Gift cards can only be received
            via email and you are able to add a message to each Gift Card
            (optional) plus you are able to choose from different Gift Card
            themes. To purchase please visit BookMyTrek Gift Card page and
            follow the prompts. People who receive a Gift Card need only to
            enter the Gift Card code into the field of the tour booking page.
            Gift Cards can be used for any bookings made where there is a
            balance remaining however Gift Cards cannot be used where the full
            amount has already been paid. Gift Cards are only valid for new
            bookings made after 1st December 2014. BookMyTrek reserves the right
            to run Special Gift Card offers, such as 300 for 200 for instance.
            Unlike standard priced Gift Cards, only one of Special Offer Gift
            Card can be used per booking and these can only be used on new
            bookings.{" "}
          </p>
          <h4>Links</h4>
          <p>
            The Services may contain links to third-party websites or resources.
            You acknowledge and agree that BookMyTrek is not responsible or
            liable for:the availability or accuracy of such websites or
            resources; orthe content, products, or services on or available from
            such websites or resources. Links to such websites or resources do
            not imply any endorsement by BookMyTrek of such websites or
            resources or the content, products, or services available from such
            websites or resources. You acknowledge sole responsibility for and
            assume all risk arising from your use of any such websites or
            resources or the Content, products or services on or available from
            such websites or resources.
          </p>
          <h4>Proprietary Rights Notices</h4>
          <p>
            All trademarks, service marks, logos, trade names and any other
            proprietary designations of BookMyTrek used herein are trademarks or
            registered trademarks of BookMyTrek . Any other trademarks, service
            marks, logos, trade names and any other proprietary designations are
            the trademarks or registered trademarks of their respective parties.
          </p>
          <h4>Feedback</h4>
          <p>
            We welcome and encourage you to provide feedback, comments and
            suggestions for improvements to the Services ("Feedback"). You may
            submit Feedback by emailing us at contact@bookmytrek.com You
            acknowledge and agree that all Feedback will be the sole and
            exclusive property of BookMyTrek and you hereby irrevocably assign
            to BookMyTrek and agree to irrevocably assign to BookMyTrek all of
            your right, title, and interest in and to all Feedback, including
            without limitation all worldwide patent, copyright, trade secret,
            moral and other proprietary or intellectual property rights therein.
            At BookMyTrek 's request and expense, you will execute documents and
            take such further acts as BookMyTrek may reasonably request to
            assist BookMyTrek to acquire, perfect, and maintain its intellectual
            property rights and other legal protections for the Feedback.
          </p>
          <h4>Copyright Policy</h4>
          <p>
            BookMyTrek respects copyright law and expects its users to do the
            same. It is BookMyTrek 's policy to terminate in appropriate
            circumstances the BookMyTrek Accounts of Members or other account
            holders who repeatedly infringe or are believed to be repeatedly
            infringing the rights of copyright holders. If you believe that your
            property has been used in any way that would be considered copyright
            infringement or a violation of your intellectual property rights,
            our copyright agent may be contacted. For more details please click
            on this link.
          </p>
          <h4>Disclaimers</h4>
          <p>
            IF YOU CHOOSE TO USE THE SERVICES, YOU DO SO AT YOUR SOLE RISK. YOU
            ACKNOWLEDGE AND AGREE THAT BookMyTrek DOES NOT HAVE AN OBLIGATION TO
            CONDUCT BACKGROUND CHECKS ON ANY MEMBER, INCLUDING, BUT NOT LIMITED
            TO, TRAVELLERS AND OPERATORS, BUT MAY CONDUCT SUCH BACKGROUND CHECKS
            IN ITS SOLE DISCRETION. THE SERVICES (INCLUDING THE SITE AND
            APPLICATION) AND COLLECTIVE CONTENT ARE PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EITHER EXPRESS OR IMPLIED. WITHOUT LIMITING
            THE FOREGOING, BookMyTrek EXPLICITLY DISCLAIMS ANY WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, QUIET ENJOYMENT
            OR NON-INFRINGEMENT, AND ANY WARRANTIES ARISING OUT OF COURSE OF
            DEALING OR USAGE OF TRADE. BookMyTrek MAKES NO WARRANTY THAT THE
            SERVICES OR COLLECTIVE CONTENT, INCLUDING, BUT NOT LIMITED TO, THE
            LISTINGS OR ANY GROUP TOURS WILL MEET YOUR REQUIREMENTS OR BE
            AVAILABLE ON AN UNINTERRUPTED, SECURE, OR ERROR-FREE BASIS.
            BookMyTrek MAKES NO WARRANTY REGARDING THE QUALITY OF ANY LISTINGS,
            GROUP TOURS, THE SERVICES OR COLLECTIVE CONTENT OR THE ACCURACY,
            TIMELINESS, TRUTHFULNESS, COMPLETENESS OR RELIABILITY OF ANY
            COLLECTIVE CONTENT OBTAINED THROUGH THE SERVICES. NO ADVICE OR
            INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED FROM BookMyTrek OR
            THROUGH THE SITE, APPLICATION, SERVICES OR COLLECTIVE CONTENT, WILL
            CREATE ANY WARRANTY NOT EXPRESSLY MADE HEREIN. YOU ARE SOLELY
            RESPONSIBLE FOR ALL OF YOUR COMMUNICATIONS AND INTERACTIONS WITH
            OTHER USERS OF THE SERVICES AND WITH OTHER PERSONS WITH WHOM YOU
            COMMUNICATE OR INTERACT AS A RESULT OF YOUR USE OF THE SERVICES,
            INCLUDING, BUT NOT LIMITED TO, ANY OPERATORS OR TRAVELLERS. YOU
            UNDERSTAND THAT BookMyTrek DOES NOT MAKE ANY ATTEMPT TO VERIFY THE
            STATEMENTS OF USERS OF THE SERVICES OR TO REVIEW OR VISIT ANY GROUP
            TOURS. BookMyTrek MAKES NO REPRESENTATIONS OR WARRANTIES AS TO THE
            CONDUCT OF USERS OF THE SERVICES OR THEIR COMPATIBILITY WITH ANY
            CURRENT OR FUTURE USERS OF THE SERVICES.
          </p>
          <p>
            YOU AGREE TO TAKE REASONABLE PRECAUTIONS IN ALL COMMUNICATIONS AND
            INTERACTIONS WITH OTHER USERS OF THE SERVICES AND WITH OTHER PERSONS
            WITH WHOM YOU COMMUNICATE OR INTERACT AS A RESULT OF YOUR USE OF THE
            SERVICES, INCLUDING, BUT NOT LIMITED TO, TRAVELLERS AND OPERATORS,
            PARTICULARLY IF YOU DECIDE TO MEET OFFLINE OR IN PERSON REGARDLESS
            OF WHETHER SUCH MEETINGS ARE ORGANIZED BY BookMyTrek OR TAKE PLACE
            DURING AN GROUP TOUR. NOTWITHSTANDING BookMyTrek 'S APPOINTMENT AS
            THE LIMITED AGENT OF THE OPERATORS FOR THE PURPOSE OF ACCEPTING
            PAYMENTS FROM TRAVELLERS ON BEHALF OF THE OPERATORS, BookMyTrek
            EXPLICITLY DISCLAIMS ALL LIABILITY FOR ANY ACT OR OMISSION OF ANY
            TRAVELER OR OTHER THIRD PARTY.
          </p>
          <h4>Limitation of Liability</h4>
          <p>
            YOU ACKNOWLEDGE AND AGREE THAT, TO THE MAXIMUM EXTENT PERMITTED BY
            LAW, THE ENTIRE RISK ARISING OUT OF YOUR ACCESS TO AND USE OF THE
            SERVICES AND COLLECTIVE CONTENT, YOUR LISTING OR BOOKING OF ANY
            GROUP TOURS VIA THE SERVICES, AND ANY CONTACT YOU HAVE WITH OTHER
            USERS WHETHER IN PERSON OR ONLINE REMAINS WITH YOU. NEITHER
            BookMyTrek NOR ANY OTHER PARTY INVOLVED IN CREATING, PRODUCING, OR
            DELIVERING THE SERVICES OR THE COLLECTIVE CONTENT WILL BE LIABLE FOR
            ANY INCIDENTAL, SPECIAL, EXEMPLARY OR CONSEQUENTIAL DAMAGES,
            INCLUDING LOST PROFITS, LOSS OF DATA OR LOSS OF GOODWILL, SERVICE
            INTERRUPTION, COMPUTER DAMAGE OR SYSTEM FAILURE OR THE COST OF
            SUBSTITUTE PRODUCTS OR SERVICES, OR FOR ANY DAMAGES FOR PERSONAL OR
            BODILY INJURY OR EMOTIONAL DISTRESS ARISING OUT OF OR IN CONNECTION
            WITH THESE TERMS, FROM THE USE OF OR INABILITY TO USE THE SERVICES
            OR COLLECTIVE CONTENT, FROM ANY COMMUNICATIONS, INTERACTIONS OR
            MEETINGS WITH OTHER USERS OF THE SERVICES OR OTHER PERSONS WITH WHOM
            YOU COMMUNICATE OR INTERACT AS A RESULT OF YOUR USE OF THE SERVICES
            OR FROM YOUR LISTING OR BOOKING OF ANY GROUP TOUR VIA THE SERVICES,
            WHETHER BASED ON WARRANTY, CONTRACT, TORT (INCLUDING NEGLIGENCE),
            PRODUCT LIABILITY OR ANY OTHER LEGAL THEORY, AND WHETHER OR NOT
            BookMyTrek HAS BEEN INFORMED OF THE POSSIBILITY OF SUCH DAMAGE, EVEN
            IF A LIMITED REMEDY SET FORTH HEREIN IS FOUND TO HAVE FAILED OF ITS
            ESSENTIAL PURPOSE. IN NO EVENT WILL = "BookMyTrek " | 'S AGGREGATE
            LIABILITY ARISING OUT OF OR IN CONNECTION WITH THESE TERMS AND YOUR
            USE OF THE SERVICES INCLUDING, BUT NOT LIMITED TO, FROM YOUR LISTING
            OR BOOKING OF ANY GROUP TOUR VIA THE SERVICES, OR FROM THE USE OF OR
            INABILITY TO USE THE SERVICES OR COLLECTIVE CONTENT AND IN
            CONNECTION WITH ANY OR INTERACTIONS WITH ANY OTHER MEMBERS, EXCEED
            THE AMOUNTS YOU HAVE PAID OR OWE FOR BOOKINGS VIA THE SERVICES AS A
            TRAVELER IN THE TWELVE (12) MONTH PERIOD PRIOR TO THE EVENT GIVING
            RISE TO THE LIABILITY, OR IF YOU ARE A GUIDE, THE AMOUNTS PAID BY =
            "BookMyTrek " | TO YOU IN THE TWELVE (12) MONTH PERIOD PRIOR TO THE
            EVENT GIVING RISE TO THE LIABILITY, OR ONE HUNDRED DOLLARS ($100),
            IF NO SUCH PAYMENTS HAVE BEEN MADE, AS APPLICABLE. THE LIMITATIONS
            OF DAMAGES SET FORTH ABOVE ARE FUNDAMENTAL ELEMENTS OF THE BASIS OF
            THE BARGAIN BETWEEN = "BookMyTrek " | AND YOU. SOME JURISDICTIONS DO
            NOT ALLOW THE EXCLUSION OR LIMITATION OF LIABILITY FOR CONSEQUENTIAL
            OR INCIDENTAL DAMAGES, SO THE ABOVE LIMITATION MAY NOT APPLY TO YOU.
          </p>
          <h4>Indemnification and Release</h4>
          <p>
            You agree to release, defend, indemnify, and hold BookMyTrek and its
            affiliates and subsidiaries, and their officers, directors,
            employees and agents, harmless from and against any claims,
            liabilities, damages, losses, and expenses, including, without
            limitation, reasonable legal and accounting fees, arising out of or
            in any way connected withyour access to or use of the Site,
            Application, Services, or Collective Content or your violation of
            these Terms;your Member Content; andyourinteraction with any
            Member,booking of an Group Tour,creation of a Listing orthe use,
            condition or quality of an Group Tour, including, but not limited to
            any injuries, losses, or damages (compensatory, direct, incidental,
            consequential or otherwise) of any kind arising in connection with
            or as a result of participating in or booking a Tour.
          </p>
          <h4>Export Control and Restricted Countries</h4>
          <p>
            You may not use, export, re-export, import, or transfer the
            Application except as authorized by Austrian law, the laws of the
            jurisdiction in which you obtained the Application, and any other
            applicable laws. In particular, but without limitation, the
            Application may not be exported or re-exported: (a) into any
            Austrian embargoed countries.
          </p>
          <h4>Reporting Misconduct</h4>
          <p>
            If you participate in an Tour with an Operator who you feel is
            acting or has acted inappropriately, including but not limited to,
            anyone whoengages in offensive, violent or sexually inappropriate
            behaviour,you suspect of stealing from you, orengages in any other
            disturbing conduct, you should immediately report such person to the
            appropriate authorities and then to BookMyTrek by contacting us with
            your police station and report number at contact@bookmytrek.com
            provided that your report will not obligate us to take any action
            beyond that required by law (if any) or cause us to incur any
            liability to you.
          </p>
          <h4>Entire Agreement</h4>
          <p>
            These Terms constitute the entire and exclusive understanding and
            agreement between BookMyTrek and you regarding the Services and
            Collective Content, and any bookings or Listings of Tours made via
            the Services, and these Terms supersede and replace any and all
            prior oral or written understandings or agreements between
            BookMyTrek and you regarding bookings or listings of Tours, the
            Services and the Collective Content.
          </p>
          <h4>Assignment</h4>
          <p>
            You may not assign or transfer these Terms, by operation of law or
            otherwise, without BookMyTrek 's prior written consent. Any attempt
            by you to assign or transfer these Terms, without such consent, will
            be null and of no effect. BookMyTrek may assign or transfer these
            Terms, at its sole discretion, without restriction. Subject to the
            foregoing, these Terms will bind and inure to the benefit of the
            parties, their successors and permitted assigns.
          </p>
          <h4>Notices</h4>
          <p>
            Any notices or other communications permitted or required hereunder,
            including those regarding modifications to these Terms, will be in
            writing and given by BookMyTrek via email (in each case to the
            address that you provide) orby posting to the Site or via the
            Application. For notices made by e-mail, the date of receipt will be
            deemed the date on which such notice is transmitted.
          </p>
          <h4>Controlling Law and Jurisdiction</h4>
          <p>
            These Terms will be interpreted in accordance with the laws of
            Jaipur, Rajasthan Jurisdiction, without regard to its
            conflict-of-law provisions. You and we agree to submit to the
            personal jurisdiction of a state court located in Jaipur, Rajasthan
            for any actions for which the parties retain the right to seek
            injunctive or other equitable relief in a court of competent
            jurisdiction to prevent the actual or threatened infringement,
            misappropriation or violation of a party's copyrights, trademarks,
            trade secrets, patents, or other intellectual property rights, as
            set forth in the Dispute Resolution provision below.
          </p>
          <h4>General</h4>
          <p>
            The failure of BookMyTrek to enforce any right or provision of these
            Terms will not constitute a waiver of future enforcement of that
            right or provision. The waiver of any such right or provision will
            be effective only if in writing and signed by a duly authorized
            representative of BookMyTrek . Except as expressly set forth in
            these Terms, the exercise by either party of any of its remedies
            under these Terms will be without prejudice to its other remedies
            under these Terms or otherwise. If for any reason an arbitrator or a
            court of competent jurisdiction finds any provision of these Terms
            invalid or unenforceable, that provision will be enforced to the
            maximum extent permissible and the other provisions of these Terms
            will remain in full force and effect.
          </p>
          <h4>Newsletters</h4>
          <p>
            By registering; using our Services and/or providing your email
            address, you understand that you will receive regular email updates
            about the platform, travel and other community related matters. Each
            email you receive shall contain a mandatory opt out at the base of
            each email to allow you to unsubscribe if you so choose.
          </p>
          <h4>Contacting BookMyTrek</h4>
          <p>
            If you have any questions about these Terms or any App Store Sourced
            Application, please contact BookMyTrek at
            <a className="alinks"> contact@bookmytrek.com</a>
          </p>{" "}
        </div>

        <Footer />
      </div>
    );
  }
}
export default TermsAndCondition;
